<template>
    <!-- 自定义设计 -->
    <div>
        <el-dialog v-if="dataActionBox.showStatus" :title="dataActionBox.boxTitle + ' - 自定义设计'" :visible.sync="dataActionBox.showStatus" append-to-body top="2rem" width="800px" center>
            <div>
                <el-tabs type="border-card" @tab-click="selOrder">
                    <el-tab-pane label="查询头">
                        <div class="design_dis">
                            <el-table v-if="formList.reportConditionVos" size="mini" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange"
                                      height="400" ref="headTable" :data="formList.reportConditionVos" border style="width: 100%" :row-key="getRowKey" @row-drag-end="handleHeadDragEnd">
                                <el-table-column type="index" width="50" label="序号"></el-table-column>
                                <el-table-column prop="fieldName" label="字段名称" show-overflow-tooltip width="180">
                                </el-table-column>
                                <el-table-column prop="fieldWeight" label="显示名称">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.fieldShow" :disabled="customShow" size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isShow" label="是否显示">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.isShow" size="mini">
                                            <el-radio-button :label="1">是</el-radio-button>
                                            <el-radio-button :label="0">否</el-radio-button>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="60" v-if="!customShow">
                                    <template>
                                        <i class="el-icon-rank drag-handle" style="cursor: move; font-size: 16px;" title="可拖拽调整顺序"></i>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="drag-tip" v-if="!customShow">
                            <i class="el-icon-info"></i> 提示：您可以拖拽任意一行来调整顺序
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="主表格头" v-if="formList.reportModuleVos.length > 0">
                        <el-tabs v-model="activeName" @tab-click="selForm">
                            <el-tab-pane :label="item.rpmName" :name="'first' + index" v-for="(item, index) in formList.reportModuleVos" :key="index">
                                <div class="design_dis">
                                    <el-table v-if="item.desysReportTableVos" size="mini" height="400" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange"
                                              :ref="'formTable' + index" :data="item.desysReportTableVos" border style="width: 100%" :row-key="getRowKey" @row-drag-end="handleFormDragEnd($event, index)">
                                        <el-table-column type="index" width="50" label="序号"></el-table-column>
                                        <el-table-column prop="fieldName" label="字段名称" show-overflow-tooltip width="180">
                                        </el-table-column>
                                        <el-table-column prop="fieldWeight" label="显示名称">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.fieldShow" size="mini" :disabled="scope.row.isCustomize == 0 || customShow"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="isShow" label="是否显示">
                                            <template slot-scope="scope">
                                                <el-radio-group v-model="scope.row.isShow" size="mini">
                                                    <el-radio-button :label="1">是</el-radio-button>
                                                    <el-radio-button :label="0">否</el-radio-button>
                                                </el-radio-group>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="isSort" label="是否排序">
                                            <template slot-scope="scope">
                                                <el-radio-group v-model="scope.row.isSort" size="mini">
                                                    <el-radio-button :label="1">是</el-radio-button>
                                                    <el-radio-button :label="0">否</el-radio-button>
                                                </el-radio-group>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="fieldWeight" label="宽度">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.fieldWeight" size="mini"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" width="60" v-if="!customShow">
                                            <template>
                                                <i class="el-icon-rank drag-handle" style="cursor: move; font-size: 16px;" title="可拖拽调整顺序"></i>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="drag-tip" v-if="!customShow">
                                    <i class="el-icon-info"></i> 提示：您可以拖拽任意一行来调整顺序
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button style="margin-right: 20px;" @click="reSetBtn()">重 置</el-button>
                <el-button @click="dataActionBox.showStatus = false">取 消</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Sortable from 'sortablejs'

export default {
    name: 'customDesignReport',
    // props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            customShow: window.global_config.customShow,
            dataActionBox: {
                showStatus: false,
                boxTitle: ''
            },
            selectedOptions: [],
            sendDataInfo: {},
            formData: {},
            countryList: [],
            pageType: '',
            formList: [], // 表单
            headData: [], // 查询条件
            activeName: 'first0',
            selectedRow: [],
            selectedDetailsIndex: 0, //主表格索引
            selectedHeadRow: [],
            selectedFormRow0: [],
            selectedFormRow1: [],
            selectedFormRow2: [],
            selectedFormRow3: [],
            selectedFormRow4: [],
            selectedFormRow5: [],
            selectedHeadIndex: 0, //查询表格索引
            selectedIndex0: 0,
            selectedIndex1: 0,
            selectedIndex2: 0,
            selectedIndex3: 0,
            selectedIndex4: 0,
            selectedIndex5: 0,
            selName: 'selectedHeadRow',
            selRef: 'headTable',
            selIndexName: 'selectedHeadIndex',
            rpcId: "",
            _uniqueIdCounter: 0, // 唯一ID计数器
            // 存储Sortable实例
            sortableHead: null,
            sortableForms: [] // 存储多个主表格头的sortable实例
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        // 监听activeName变化，在切换tab时初始化对应表格的拖拽功能
        activeName: {
            handler(newVal) {
                this.$nextTick(() => {
                    const formIndex = parseInt(newVal.replace('first', ''));
                    if (!isNaN(formIndex)) {
                        this.initSingleFormDrag(formIndex);
                    }
                });
            },
            immediate: false
        }
    },
    //方法集合
    methods: {
        // 生成唯一ID
        generateUniqueId() {
            return `unique_row_id_${this._uniqueIdCounter++}`
        },

        // 确保每行数据都有唯一ID
        ensureUniqueIds(dataArray) {
            if (!dataArray) return
            dataArray.forEach(item => {
                if (!item._uniqueId) {
                    item._uniqueId = this.generateUniqueId()
                }
            })
        },

        // 获取行的唯一key
        getRowKey(row) {
            return row._uniqueId
        },

        // 初始化拖拽功能
        initDrag() {
            this.initHeadDrag()
            this.initFormDrag()
        },

        // 初始化查询头拖拽
        initHeadDrag() {
            if (!this.formList.reportConditionVos) return

            this.ensureUniqueIds(this.formList.reportConditionVos)

            const headTable = this.$refs.headTable
            if (headTable && headTable.$el) {
                if (this.sortableHead) {
                    this.sortableHead.destroy()
                    this.sortableHead = null
                }
                this.sortableHead = Sortable.create(headTable.$el.querySelector('tbody'), {
                    handle: '.drag-handle',
                    onEnd: (evt) => {
                        const oldIndex = evt.oldIndex
                        const newIndex = evt.newIndex

                        const movedRow = this.formList.reportConditionVos.splice(oldIndex, 1)[0]
                        this.formList.reportConditionVos.splice(newIndex, 0, movedRow)

                        this.updateSortOrder(this.formList.reportConditionVos)
                    }
                })
            }
        },

        // 初始化主表格头拖拽
        initFormDrag() {
            if (!this.formList.reportModuleVos) return

            this.sortableForms.forEach(instance => {
                if (instance) instance.destroy()
            })
            this.sortableForms = []

            this.formList.reportModuleVos.forEach((item, index) => {
                if (!item.desysReportTableVos) {
                    this.sortableForms[index] = null
                    return
                }

                this.ensureUniqueIds(item.desysReportTableVos)

                if (this.activeName === `first${index}`) {
                    this.$nextTick(() => {
                        this.initSingleFormDrag(index)
                    })
                }
            })
        },

        // 初始化单个主表格头拖拽
        initSingleFormDrag(index) {
            if (!this.formList.reportModuleVos ||
                !this.formList.reportModuleVos[index] ||
                !this.formList.reportModuleVos[index].desysReportTableVos) {
                return
            }

            this.$nextTick(() => {
                const formTable = this.$refs[`formTable${index}`]
                if (formTable && Array.isArray(formTable) && formTable.length > 0 && formTable[0].$el) {
                    const tableEl = formTable[0].$el
                    const tbody = tableEl.querySelector('tbody')
                    if (tbody) {
                        if (this.sortableForms[index]) {
                            this.sortableForms[index].destroy()
                        }

                        this.sortableForms[index] = Sortable.create(tbody, {
                            handle: '.drag-handle',
                            onEnd: (evt) => {
                                const oldIndex = evt.oldIndex
                                const newIndex = evt.newIndex

                                const movedRow = this.formList.reportModuleVos[index].desysReportTableVos.splice(oldIndex, 1)[0]
                                this.formList.reportModuleVos[index].desysReportTableVos.splice(newIndex, 0, movedRow)

                                this.updateSortOrder(this.formList.reportModuleVos[index].desysReportTableVos)
                            }
                        })
                    } else {
                        setTimeout(() => {
                            this.initSingleFormDrag(index)
                        }, 100)
                    }
                } else {
                    setTimeout(() => {
                        this.initSingleFormDrag(index)
                    }, 100)
                }
            })
        },

        // 更新排序字段
        updateSortOrder(array) {
            array.forEach((item, index) => {
                item.sort = index + 1
                item.fieldSort = index + 1
            })
        },

        // 处理查询头拖拽结束事件
        handleHeadDragEnd() {
            // 保留此方法以兼容模板中的事件绑定，但实际逻辑已在Sortable的onEnd中处理
        },

        // 处理主表格头拖拽结束事件
        handleFormDragEnd() {
            // 保留此方法以兼容模板中的事件绑定，但实际逻辑已在Sortable的onEnd中处理
        },

        async reSetBtn() {
            this.$confirm('确定要重置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let responseData = await this.$http.jurconfigClearUserJur(
                    { reportId: this.rpcId, jurId: parent.getMenuInfo(this.$route.path).jurId }
                );
                if (responseData.status == 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    this.$parent.getPageInfo()
                    this.dataActionBox.showStatus = false
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }).catch(() => { });
        },

        async sendDataAction() {
            console.log(this.formList);
            var formlist = JSON.parse(JSON.stringify(this.formList))
            var conditionList = []
            var tableData = [];
            formlist.reportConditionVos.forEach(item => {
                item.rpcId = this.rpcId
                conditionList.push(item)
            })
            formlist.reportModuleVos.forEach(item => {
                tableData.push({
                    tableList: item.desysReportTableVos
                })
            })
            let params = {
                conditionList: conditionList,
                tableData: tableData,
            }
            let responseData = await this.$http.addUserCustom(
                params
            );
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$parent.getPageInfo()
                this.dataActionBox.showStatus = false
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        selOrder(e) {
            let selIndex = Number(e.index)
            if (selIndex == 0) {
                this.selName = 'selectedHeadRow'
                this.selRef = 'headTable'
                this.selIndexName = 'selectedHeadIndex'
                this.$nextTick(() => {
                    this.initHeadDrag()
                })
            } else if (selIndex == 1) {
                this.selName = 'selectedFormRow0'
                this.selRef = 'formTable0'
                this.selIndexName = 'selectedIndex0'
                this.$nextTick(() => {
                    const formIndex = parseInt(this.activeName.replace('first', ''));
                    if (!isNaN(formIndex)) {
                        this.initSingleFormDrag(formIndex);
                    }
                })
            }
        },

        selForm(e) {
            let selFormIndex = Number(e.index)
            this.selName = 'selectedFormRow' + selFormIndex
            this.selRef = 'formTable' + selFormIndex
            this.selIndexName = 'selectedIndex' + selFormIndex

            // 切换tab时初始化对应表格的拖拽
            this.$nextTick(() => {
                this.initSingleFormDrag(selFormIndex)
            })
        },

        //初始化
        init() { },

        //父级传入
        openBox(rpcId, formList, title) {
            this.formList = JSON.parse(JSON.stringify(formList))
            this.dataActionBox.boxTitle = title
            this.rpcId = rpcId

            // 初始化唯一ID计数器
            if (!this._uniqueIdCounter) {
                this._uniqueIdCounter = new Date().getTime() + Math.floor(Math.random() * 10000)
            }

            // 为所有数据项添加唯一ID
            if (this.formList.reportConditionVos) {
                this.ensureUniqueIds(this.formList.reportConditionVos)
            }
            if (this.formList.reportModuleVos) {
                this.formList.reportModuleVos.forEach(item => {
                    if (item.desysReportTableVos) {
                        this.ensureUniqueIds(item.desysReportTableVos)
                    }
                })
                if (this.formList.reportModuleVos.length > 0) {
                    this.activeName = 'first0'
                }
            }

            this.dataActionBox.showStatus = true

            this.$nextTick(() => {
                this.initDrag()
            })
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this[this.selName] = rows; // 保存已选择行
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            console.log(row, column, event, params)
            let refsElTable = this.$refs[this.selRef]; // 获取表格对象
            refsElTable = refsElTable.length == 1 ? this.$refs[this.selRef][0] : this.$refs[this.selRef]
            let findRow = {};
            this[this.selIndexName] = row.rowIndex;
            findRow = this[this.selName].find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this[this.selName].length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 表格方法
        rowClassName({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this[this.selName].find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() {
        if (!this._uniqueIdCounter) {
            this._uniqueIdCounter = Date.now() + Math.floor(Math.random() * 10000)
        }
    }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { //生命周期 - 销毁之前
        if (this.sortableHead) this.sortableHead.destroy()
        if (this.sortableForms && this.sortableForms.length > 0) {
            this.sortableForms.forEach(instance => {
                if (instance) instance.destroy()
            })
        }
    },
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.design_dis {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.sort {
    width: 55px;
    margin-left: 14px;
}

.sort .el-button {
    padding: 4px;
    margin-left: 0 !important;
    margin-bottom: 10px;
}

.sort .el-button i {
    font-size: 20px;
}

.el-table .rowStyle {
    background: #fff7ca !important;
}

.drag-handle {
    cursor: move;
}

.drag-tip {
    margin-top: 10px;
    padding: 8px 12px;
    background-color: #f4f4f5;
    border: 1px solid #e9e9eb;
    border-radius: 4px;
    color: #606266;
    font-size: 13px;
}

.drag-tip i {
    color: #909399;
    margin-right: 5px;
}

/* sortable样式 */
.sortable-ghost {
    opacity: 0.4;
}

.el-tabs--border-card {
    margin: 0 !important;
}
</style>
